const SHARE_ICONS = [
    {name: 'facebook', icon: 'fb', title: 'Facebook', callback: 'shareByFacebook'},
    {name: 'linkedin', icon: 'linkd', title: 'LinkedIn', callback: 'shareByLinkedIn'},
    {name: 'messenger', icon: 'messg', title: 'Messenger', callback: 'shareByMessenger'},
    {name: 'email', icon: 'email', title: 'Email', callback: 'shareByEmail'},
    {name: 'twitter', icon: 'tw', title: 'Twitter', callback: 'shareByTwitter'},
    {name: 'print', icon: 'print', title: 'Nyomtatás', callback: 'printArticle'}
];
const COLUMNS = 2;

function addIconsToPage()
{
    if ($('#shareicons').length) {
        return;
    }
    var sharePanel = $('<span id="shareicons" style="display:none"></span>');
    var rowCount = Math.ceil(SHARE_ICONS.length / COLUMNS);
    for (i = 0; i < rowCount; i++) {
        var row = $('<div class="s-row"></div>').appendTo(sharePanel);
        iconOfCol(i * COLUMNS).appendTo(row);
        iconOfCol(i * COLUMNS + 1).appendTo(row);
    }
    $('body').append(sharePanel);
}

function iconOfCol(colIndex)
{
    return $('<div class="s-cell ' + SHARE_ICONS[colIndex].name + '"></div>')
                    .append('<img src="https://assets.portfolio.hu/images/icon-' + SHARE_ICONS[colIndex].icon + '.gif" alt="" class="share-btn"><span>' + SHARE_ICONS[colIndex].title + '</span>');
}

function addSharePopover(shareLink)
{
    addIconsToPage();

    $(shareLink).popover({
        html     : true,
        placement: "top",
        content  : function() {
            var shtml = $("#shareicons").html();
                return shtml;
            }
        });

    $(shareLink).on('shown.bs.popover', function(){
        $('.s-cell').click(function(){
            sharePage($(this).attr('class').replace(/s-cell/g, '').trim());
        });
    });
}

function sharePage(sharer)
{
    var shareIcon = SHARE_ICONS.find(function(icon){
        if (icon.name == sharer) {
            return icon;
        }
        return null;
    });
    if (!shareIcon) {
        return;
    }
    ShareAndSave[shareIcon.callback]();
}

function shareByFacebook()
{
    popupWindow('https://www.facebook.com/sharer/sharer.php?u=' + document.location.href);
}

function shareByLinkedIn()
{
    popupWindow('https://www.linkedin.com/');
}

function shareByMessenger()
{
    popupWindow('https://messenger.com/');
}

function shareByEmail()
{
    window.open('mailto:?subject=' + getTitle() + '&body=' + document.location.href);
}

function shareByTwitter()
{
    popupWindow('https://twitter.com/share?lang=hu&text=' + getTitle() + '&url=' + document.location.href);
}

function getTitle() {
    return $('h1').text();
}

function printArticle()
{
    var prefix = document.location.href.match(/\?/g) ? '&' : '?';
    window.open(document.location.href + prefix + 'print=1');
}

function popupWindow(url)
{
	window.open(url,'popUpWindow','height=600,width=600,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=no');
}

function addSaveFunction(saveLink)
{
    $(saveLink).click(function(){
        // A felhasználó be van jelentkezve
        if ($('.user-menu[data-logged="true"]').length) {
            saveUnsave();
        } else {
            showPopover('A cikk mentéséhez kérjük,<br><a href="javascript:void(ShareAndSave.openLogin())">jelentkezzen be</a>.');
        }
    });
}

function saveUnsave()
{
    var id = $('meta[property="pf:article"]').attr('content');
    if ($('.article-save').hasClass('saved')) {
        unsaveArticle(id);
    } else {
        saveArticle(id);
    }
}

function unsaveArticle(id)
{
    $.post('/torles', { article: id }, function(){
        showPopover('Sikeresen eltávolítva a cikkgyűjteményből.');
        $('.article-save').css('opacity', 0.5).removeClass('saved');
    }).fail(function() {
        alert( "Nem sikerült a cikk eltávolítása." );
    });
}

function saveArticle(id)
{
    $.post('/mentes', { article: id }, function(){
        showPopover('Sikeresen hozzáadva a <a href="https://profil.portfolio.hu" target="_blank">cikkgyűjteményhez.</a>');
        $('.article-save').css('opacity', 0.5).addClass('saved');
    }).fail(function() {
        alert( "Nem sikerült a cikk mentése." );
    });
}

function showPopover(content) {
    $('.article-save').popover({
        container: 'body',
        html     : true,
        sanitize : false,
        placement: 'top',
        content  : content
    }).popover('show');
    setTimeout(function(){
        $('.article-save').popover('dispose');
    }, 4500);
}

function openLogin()
{
    $("html").scrollTop(0);
    $('.article-save').popover('hide');
    $('#login-link').trigger('click');
}

$(function()
{
    $('body').on('click', function (e) {
        $('.article-share, .article-save, #loginpop').each(function () {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });
});

module.exports = {
    addSharePopover : addSharePopover,
    addSaveFunction : addSaveFunction,
    shareByFacebook : shareByFacebook,
    shareByLinkedIn : shareByLinkedIn,
    shareByMessenger: shareByMessenger,
    shareByEmail    : shareByEmail,
    shareByTwitter  : shareByTwitter,
    printArticle    : printArticle,
    showPopover     : showPopover,
    openLogin       : openLogin
};
